export const authNames = {
    ADMIN_APP_TOKEN: 'ADMIN_APP_TOKEN',
    ADMIN_APP_REFRESH_TOKEN: 'ADMIN_APP_REFRESH_TOKEN',
} as const

export type AuthName = (typeof authNames)[keyof typeof authNames]
